import React, { FC, PropsWithChildren } from 'react';

import { PlayerInstance } from '@/scenarios/legacy-player/components/PlayerInstance/PlayerInstance';
import { PlayerConfig } from '@/scenarios/legacy-player/types/config';

import { useOnLoadingError } from './hooks/use-on-loading-error';

export type PlayerType = 'promo' | 'trailer' | 'channel' | 'film' | 'episode' | 'clip' | 'sport';

interface Props {
    config: PlayerConfig;
    type?: 'promo';
}

export const Player: FC<PropsWithChildren<Props>> = ({ config, type, children }) => {
    const { onLoadingError } = useOnLoadingError(type);

    return (
        <PlayerInstance config={config} onLoadingError={onLoadingError} useYasp>
            {children}
        </PlayerInstance>
    );
};
